import {PATH_DASHBOARD} from '@feg/ui'
import {useTranslation} from 'react-i18next'
import ZoneList from '../../../components/admin/zone/ZoneList'
import AddEditZoneButton from '../../../components/admin/zone/AddEditZoneButton'
import {PageRoot} from "@feg/ui/src/common/layout/PageRoot";


export default function ZonePage() {
    const {t} = useTranslation()
    return (
        <PageRoot title={t('zone.list.main')}
                  breadcrumbs={{
                      heading: t('zone.list.main'),
                      links: [
                          {name: t('dashboard.main'), href: PATH_DASHBOARD.general.app},
                          {name: t('zone.list.main'), href: PATH_DASHBOARD.location.zoneList}
                      ],
                      action: (
                          <AddEditZoneButton/>
                      )
                  }}>
            <ZoneList/>
        </PageRoot>
    )
}


